import { useResetStore } from '~/composables/common/use-reset-store'
import { AUTH_API } from '~/configs/api'
import { useApi } from '~/composables/common/use-api'
import { useResetCookie } from '~/composables/common/use-reset-cookie'

export function useLogout() {
  const { request } = useApi()
  const resetStore = useResetStore()
  const { resetCookie } = useResetCookie()

  async function submitLogout(isRedirectToHome: boolean = true): Promise<void> {
    try {
      await request(AUTH_API.LOG_OUT, {
        method: 'GET'
      })
    } finally {
      resetStore.all()
      resetCookie()
      if (isRedirectToHome) {
        window.location.href = '/'
      }
    }
  }

  return {
    submitLogout
  }
}
